export const LocationTargetTypes = {
  New: 'New',
  Included: 'Included',
  Excluded: 'Excluded',
  Recommended: 'Recommended',
};
